export const LANGUAGES = ["es", "en"];
export const DEFAULT_LANGUAGE = "es";

export const TRANSLATIONS = {
  es: {
    nav: {
      links: {
        nosotros: "Nosotros",
        servicios: "Servicios",
        proyectos: "Proyectos",
        apps: "Apps",
        contacto: "Contacto",
      },
      cta: "Hablemos",
      openMenu: "Abrir menú",
      closeMenu: "Cerrar menú",
      menu: "Menú",
      mobileCta: "Hablemos de tu proyecto",
      switchLanguage: "Cambiar idioma a inglés",
    },
    hero: {
      badge: "Disponibles para nuevos proyectos",
      titleStart: "Convertimos ideas en ",
      titleAccent: "software",
      titleEnd: " que la gente usa.",
      text: "Somos un estudio pequeño formado por dos amigos apasionados por crear software. Apps móviles, sitios web, backend o inteligencia artificial: si se puede programar, lo construimos contigo.",
      primary: "Ver proyectos",
      secondary: "Cuéntanos tu idea",
      scroll: "Bajar a Nosotros",
    },
    about: {
      eyebrow: "Nosotros",
      title: "Dos amigos, una misma obsesión: hacer buen software.",
      text: "Casvi nació de las ganas de construir cosas propias. Diseñamos, programamos y publicamos nuestros productos de principio a fin, y ahora ponemos esa misma experiencia al servicio de tu proyecto.",
      values: [
        {
          title: "Pasión",
          text: "Hacemos software porque nos encanta. Cada proyecto lo tratamos como si fuera nuestro.",
        },
        {
          title: "Cercanía",
          text: "Hablas directo con quienes diseñan y programan tu producto. Sin intermediarios.",
        },
        {
          title: "Calidad",
          text: "Código limpio, diseño cuidado y apps que se publican y se mantienen en el tiempo.",
        },
      ],
    },
    services: {
      eyebrow: "Servicios",
      title: "Hacemos software de todo tipo.",
      swipe: "Desliza para ver más →",
      items: [
        {
          title: "Apps móviles",
          text: "Apps nativas para iOS y multiplataforma para iOS y Android, listas para publicarse en las tiendas.",
        },
        {
          title: "Sitios y apps web",
          text: "Desde páginas para tu negocio hasta plataformas web completas con panel de administración.",
        },
        {
          title: "Backend y nube",
          text: "APIs, bases de datos y servicios en la nube para que tu producto escale sin problemas.",
        },
        {
          title: "Inteligencia artificial",
          text: "Integramos IA en tus productos: asistentes, automatización y funciones inteligentes.",
        },
      ],
    },
    projects: {
      eyebrow: "Proyectos",
      title: "Lo que ya construimos.",
      download: "Descargar en App Store",
      downloadPlay: "Descargar en Google Play",
      view: "Ver app",
      comingSoon: "Próximamente",
      next: {
        title: "Tu proyecto podría ser el siguiente",
        text: "Estamos trabajando en nuevas apps y buscando ideas para construir juntos.",
        cta: "Hablemos",
      },
    },
    contact: {
      eyebrow: "Contacto",
      title: "¿Tienes una idea? Hagámosla realidad.",
      textStart: "Cuéntanos qué quieres construir y te respondemos lo antes posible. También puedes escribirnos directo a ",
      name: "Nombre",
      namePlaceholder: "Tu nombre",
      email: "Correo electrónico",
      emailPlaceholder: "tu@correo.com",
      message: "Mensaje",
      messagePlaceholder: "Cuéntanos sobre tu proyecto",
      submit: "Enviar mensaje",
      sending: "Enviando mensaje...",
      successTitle: "¡Mensaje enviado!",
      success: "Gracias por escribirnos. Ya nos llegó tu mensaje y te responderemos muy pronto.",
      invalidTitle: "Revisa tus datos",
      invalid: "Algo no cuadra con la información del formulario. Verifica tu correo y tu mensaje e inténtalo de nuevo.",
      errorTitle: "No pudimos enviarlo",
      error: "Tuvimos un problema al enviar tu mensaje. Intenta de nuevo en unos minutos o escríbenos directo a hola@casvisoftware.com.",
      confirm: "Entendido",
      validation: {
        nameRequired: "Tu nombre es obligatorio",
        emailInvalid: "Correo electrónico inválido",
        emailRequired: "Tu correo es obligatorio",
        messageMin: "Cuéntanos un poco más (mínimo 10 caracteres)",
        messageRequired: "El mensaje es obligatorio",
      },
    },
    apps: {
      navLabel: "Apps",
      eyebrow: "Nuestras apps",
      title: "Apps hechas por Casvi.",
      text: "Cada app tiene su página con lo que hace, ayuda para resolver dudas y su política de privacidad.",
      view: "Ver app",
      about: "Acerca de",
      privacy: "Privacidad",
      privacyTitle: "Política de privacidad",
      features: "Qué puedes hacer",
      support: "Soporte",
      download: "Descargar en App Store",
      downloadPlay: "Descargar en Google Play",
      comingSoon: "Próximamente en App Store",
      writeUs: "Escríbenos",
      readPrivacy: "Lee nuestra política de privacidad",
      privacyCta: "Consulta cómo cuidamos tu información en la política de privacidad.",
      plans: "Planes",
      terms: "Términos",
      termsTitle: "Términos y condiciones",
      readTerms: "Lee los términos y condiciones",
      termsCta: "Las reglas para clientes y negocios que usan la app.",
      back: "Todas las apps",
      pageTitle: "Apps",
    },
    footer: {
      rights: "Todos los derechos reservados.",
    },
    notFound: {
      subtitle: "Oops... Página no encontrada",
      back: "Volver al inicio",
    },
    input: {
      show: "Ver",
      hide: "Ocultar",
    },
  },

  en: {
    nav: {
      links: {
        nosotros: "About",
        servicios: "Services",
        proyectos: "Projects",
        apps: "Apps",
        contacto: "Contact",
      },
      cta: "Let's talk",
      openMenu: "Open menu",
      closeMenu: "Close menu",
      menu: "Menu",
      mobileCta: "Tell us about your project",
      switchLanguage: "Switch language to Spanish",
    },
    hero: {
      badge: "Available for new projects",
      titleStart: "We turn ideas into ",
      titleAccent: "software",
      titleEnd: " people actually use.",
      text: "We're a small studio founded by two friends who love building software. Mobile apps, websites, backend or artificial intelligence: if it can be coded, we'll build it with you.",
      primary: "See projects",
      secondary: "Tell us your idea",
      scroll: "Scroll to About",
    },
    about: {
      eyebrow: "About us",
      title: "Two friends, one obsession: building great software.",
      text: "Casvi was born from the urge to build our own things. We design, code and ship our products end to end, and now we bring that same experience to your project.",
      values: [
        {
          title: "Passion",
          text: "We build software because we love it. We treat every project as if it were our own.",
        },
        {
          title: "Closeness",
          text: "You talk directly with the people who design and code your product. No middlemen.",
        },
        {
          title: "Quality",
          text: "Clean code, careful design and apps that ship and keep being maintained.",
        },
      ],
    },
    services: {
      eyebrow: "Services",
      title: "We build all kinds of software.",
      swipe: "Swipe to see more →",
      items: [
        {
          title: "Mobile apps",
          text: "Native iOS apps and cross-platform apps for iOS and Android, ready to ship to the stores.",
        },
        {
          title: "Websites & web apps",
          text: "From pages for your business to full web platforms with an admin dashboard.",
        },
        {
          title: "Backend & cloud",
          text: "APIs, databases and cloud services so your product scales without a hitch.",
        },
        {
          title: "Artificial intelligence",
          text: "We bring AI into your products: assistants, automation and smart features.",
        },
      ],
    },
    projects: {
      eyebrow: "Projects",
      title: "What we've built.",
      download: "Download on the App Store",
      downloadPlay: "Get it on Google Play",
      view: "View app",
      comingSoon: "Coming soon",
      next: {
        title: "Your project could be next",
        text: "We're working on new apps and looking for ideas to build together.",
        cta: "Let's talk",
      },
    },
    contact: {
      eyebrow: "Contact",
      title: "Got an idea? Let's make it real.",
      textStart: "Tell us what you want to build and we'll get back to you as soon as possible. You can also email us directly at ",
      name: "Name",
      namePlaceholder: "Your name",
      email: "Email",
      emailPlaceholder: "you@email.com",
      message: "Message",
      messagePlaceholder: "Tell us about your project",
      submit: "Send message",
      sending: "Sending message...",
      successTitle: "Message sent!",
      success: "Thanks for reaching out. We got your message and will get back to you very soon.",
      invalidTitle: "Check your details",
      invalid: "Something's off with the form. Double-check your email and message and try again.",
      errorTitle: "We couldn't send it",
      error: "Something went wrong sending your message. Try again in a few minutes or email us directly at hola@casvisoftware.com.",
      confirm: "Got it",
      validation: {
        nameRequired: "Your name is required",
        emailInvalid: "Invalid email address",
        emailRequired: "Your email is required",
        messageMin: "Tell us a bit more (at least 10 characters)",
        messageRequired: "A message is required",
      },
    },
    apps: {
      navLabel: "Apps",
      eyebrow: "Our apps",
      title: "Apps made by Casvi.",
      text: "Each app has its own page with what it does, help for common questions and its privacy policy.",
      view: "View app",
      about: "About",
      privacy: "Privacy",
      privacyTitle: "Privacy policy",
      features: "What you can do",
      support: "Support",
      download: "Download on the App Store",
      downloadPlay: "Get it on Google Play",
      comingSoon: "Coming soon to the App Store",
      writeUs: "Email us",
      readPrivacy: "Read our privacy policy",
      privacyCta: "See how we take care of your information in our privacy policy.",
      terms: "Terms",
      termsTitle: "Terms and conditions",
      plans: "Plans",
      readTerms: "Read the terms and conditions",
      termsCta: "The rules for customers and businesses using the app.",
      back: "All apps",
      pageTitle: "Apps",
    },
    footer: {
      rights: "All rights reserved.",
    },
    notFound: {
      subtitle: "Oops... Page not found",
      back: "Back to home",
    },
    input: {
      show: "Show",
      hide: "Hide",
    },
  },
};
